import './ResetPasswordForm.scss';
import { Input } from '@components/Component/Field/Input/Input.js';
import { InputPassword } from '@components/Component/Field/Input/InputPassword/InputPassword.js';
import { Form } from '@components/Component/Container/Form/Form.js';
import { Button } from '@components/Component/Button/Button.js';
import { DataRecord } from '@components/DataRecord/DataRecord.js';
import { getID } from '@components/Utility/index.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { ScreenCover } from "@components/Component/Container/Screen/ScreenCover/ScreenCover.js";
/**
 * `ResetPasswordForm` class that extends `Form`.
 * This class represents a reset password page with input fields for userid, security code, new password and confirm passowrd with a reset password button.
 */
export class ResetPasswordForm extends Form {
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'ResetPasswordForm';
        this.loadExternalData = false;
    }
    initializeRecords() {
        this.record = new DataRecord(getID('ResetPasswordForm'));
    }
    initializeComponents() {
        const userid = new Input('userid');
        userid.propertiesLoad({
            captionKey: 'login_userid',
            largeField: true,
            labelPosition: 'top'
        });
        const token = new InputPassword('token');
        token.propertiesLoad({
            captionKey: 'system_login_securitycode',
            largeField: true,
            labelPosition: 'top'
        });
        const newpassword = new InputPassword('newpassword');
        newpassword.propertiesLoad({
            captionKey: 'system_login_newpassword',
            largeField: true,
            maxLength: 200,
            labelPosition: 'top'
        });
        const confirmpassword = new InputPassword('confirmpassword');
        confirmpassword.propertiesLoad({
            captionKey: 'system_login_confirmpassword',
            largeField: true,
            maxLength: 200,
            labelPosition: 'top'
        });
        const submit = new Button('submit');
        submit.propertiesLoad({
            captionKey: 'system_login_resetpassword',
            buttonSize: 'large'
        });
        const newPasswordCaption = this.getCaption('login_newpassword_placeholder');
        const usernameCaption = this.getCaption('login_userid_placeholder');
        const securityCodeCaption = this.getCaption('login_securitycode_placeholder');
        submit.before('click', () => {
            if (!this.record.get('userid')) {
                this.alert({ caption: this.getCaption('system_requiredfield_caption', { field: usernameCaption }), modalStyle: 'error' });
                return false;
            }
            if (!this.record.get('token')) {
                this.alert({ caption: this.getCaption('system_requiredfield_caption', { field: securityCodeCaption }), modalStyle: 'error' });
                return false;
            }
            if (!this.record.get('newpassword')) {
                this.alert({ caption: this.getCaption('system_requiredfield_caption', { field: newPasswordCaption }), modalStyle: 'error' });
                return false;
            }
            if (!this.record.get('confirmpassword')) {
                this.alert({ caption: this.getCaption('login_confirmpassword_caption'), modalStyle: 'error' });
                return false;
            }
            return true;
        });
        submit.on('click', () => {
            this.resetPassword();
        });
        const returntologin = DIContainer.new('TextBase', 'returntologin');
        returntologin.propertiesLoad({
            captionKey: 'system_login_auth_returntologin',
            textElementType: 'a',
            zoomTemplate: '/'
        });
        returntologin.on('click', (a) => {
            this.returnToLogin();
        });
        // returntologin.on('click', () => {
        // 	this.returnToLogin();
        // });
        this.componentsAdd([
            userid,
            token,
            newpassword,
            confirmpassword,
            submit,
            returntologin
        ]);
    }
    /**
     * Executes resetPassword request to server to change password and redirect to the LoginForm
     */
    resetPassword() {
        this.Request.POST({
            endpoint: 'authenticate',
            action: 'resetpassword',
            loadingMessage: this.getCaption('system_loading_caption'),
            requestData: {
                userid: this.record.get('userid'),
                password: this.record.get('newpassword'),
                password2: this.record.get('confirmpassword'),
                token: this.record.get('token')
            }
        }).subscribe(() => {
            this.returnToLogin();
        });
    }
    /**
     * Redirects to the Login Page
     */
    returnToLogin() {
        const screenManager = DIContainer.getInstance('ScreenManager');
        if (this.screenGet() instanceof ScreenCover) {
            screenManager.open(DIContainer.new('LoginFormOverlay'), {
                screenCover: true,
                requestParams: {
                    userid: this.record.get('userid')
                }
            });
        }
        else {
            this.navigate('/', {
                userid: this.record.get('userid')
            });
        }
    }
    mainHeadingCaptionGet(subHeading = false) {
        let caption;
        if (subHeading) {
            caption = this.CaptionManager.getCaption('system_resetpassword_subheading');
        }
        else {
            caption = this.CaptionManager.getCaption('system_resetpassword_heading');
        }
        return caption;
    }
    template() {
        return `<div class="form-cover"></div>
<div class="form-wrapper">

<div class="form-container">
		<header>
			<span class="branding-logo">
			
			</span>
			<span class="heading">${this.CaptionManager.getCaption('system_login_resetpasswordheading')}</span>
<span class="sub-heading">${this.CaptionManager.getCaption('system_login_resetpasswordsubheading')}</span>
		</header>
		<form class="thin">
			<div class="form-group">
				<span data-componentid="userid"></span>
			</div>
			<div class="form-group">
				<span data-componentid="token"></span>
			</div>
			<div class="form-group">
				<span data-componentid="newpassword"></span>
			</div>
			<div class="form-group">
				<span data-componentid="confirmpassword"></span>
			</div>
			<div class="form-group">
				<span data-componentid="submit"></span>
			</div>
			<div class="form-group">
				<div class="return-container">
					<span data-componentid="returntologin"></span>
				</div>
			</div>
		</form>
</div>
</div>`;
    }
}
ResetPasswordForm.VERSION = '$Revision: 112885 $';
